<template>
    <div class="steps_bar">
        <!-- <div class="steps_bar_pc" v-show="current!=6">
            <div class="bar_container" >
                <p class="first" :class="{current_prev: current == 0}"></p>
                <p v-for="(item, index) in header" :key="index" :class="{current: index == current, last: index == 5, done: index < current, current_prev: index == (current - 1)}">
                    <span>{{item.name}}</span>
                </p>
            </div> 
        </div> -->
        <div class="steps_bar_pc" v-show="current != 6">
            <div class="bar-box">
                <div class="bar-item" :class="{'active-item': current == index}" v-for="(item, index) in header">
                    <span class="front" :class="{'active-front': current == index}"></span>
                    <span class="middle" :class="{'active-middle': current == index}">{{item.name}}</span>
                    <span class="end" :class="{'active-end': current == index}"></span>
                </div>
            </div>
        </div>
        <div class="steps_bar_iphone" v-show="current!=6"> 
            <div v-for="(item, index) in header" :key="index" v-show="index == current">
                <span class="steps_bar_iphone_name" style="float:left;">{{item.name}}</span>
                <span class="steps_bar_iphone_num" style="float:right;">{{index+1}}/6</span>
            </div>
        </div>
        <span class="preview" v-show="current==6">{{this.$t('header.previewPage')}}</span>
    </div>
</template>

<script>
    export default {
        props:['current'],
        data() {
            return {}
        },
        computed:{
            header(){
                let headers=[]
                let items=this.$t('header');
                let arr=['personalDetails1','personalDetails2','financialDetails','Experience','Knowledge','Acknowledgements']
                let i=0;
                for(let key in arr){
                    let obj={}
                    obj.id=i;
                    obj.name=items[arr[key]];
                    headers.push(obj)
                }
                return  headers; 
            }
        }
    }
</script>

<style scoped lang="scss">
    .mobileType{
        .steps_bar .steps_bar_iphone{
            display: block;
        }
        .steps_bar p span{
            padding:0 50px;
        }
    }
    .pcType{
        .steps_bar .steps_bar_pc{
            display: block;
            .bar_container{
                display: flex;
                margin:0 auto;
                width: 80%;
                position: relative;
                padding-left:20px;
                &>p{
                    flex: 1;
                    &>span{
                        display:table-cell;
                        vertical-align: middle
                    }
                }
            }
            .bar-box{
                width: 80%;
                margin: 0 auto;
                position: relative;
                .bar-item{
                    display: inline-block;
                    width: 16.66%;
                    position: relative;
                    span{ 
                        display: inline-block;
                    }
                    .front{
                        position: absolute;
                        left: -18px;
                        top: 0;
                        width: 18px;
                        height: 60px;
                    }
                    .active-front{
                        background:url(./../assets/images/stepbar.png) no-repeat;
                        background-position: 0 -60px;
                    }
                    .middle{
                        width: 100%;
                        height: 58px;
                        line-height: 58px;
                        border-top: 1px solid #f1f1f1;
                        border-bottom: 1px solid #f1f1f1;
                        font-weight: 700;
                        
                    }
                    .active-middle{
                        background-color: #f2672a;
                        color: #fff;
                    }
                    .end{
                        position: absolute;
                        right: -18px;
                        top: 0;
                        width: 18px;
                        height: 60px;
                        background:url(./../assets/images/stepbar.png) no-repeat;
                        background-position: 0 -180px;
                    }
                    .active-end{
                        background-position: 0 -240px;
                    }
                }
            }
        }
    }
    .steps_bar_iphone,.steps_bar_pc,.bar_container{
        display: none;
    }
    .steps_bar{width: 100%; background: #f1f1f1;text-align:center;}
    .steps_bar p { display: table; height:60px; padding-right:18px; text-align:center; background:url(./../assets/images/stepbar.png) no-repeat 100% 0 #f1f1f1; font-weight:bold;margin:0;} 
    .steps_bar p span { display:block; height:58px;background:#f1f1f1; border-top:solid 1px #fff; border-bottom:solid 1px #fff;} 
    .steps_bar p.done { color:#999; background-position:100% -120px; background-color:#f1f1f1;}
    .steps_bar p.current_prev { color:#999; background-position:100% -60px; background-color:#f1f1f1;} 
    .steps_bar p.done span, .steps_bar ul li.current_prev span { background:#f1f1f1;} 
    .steps_bar p.current { color:#fff; background-color:#f2672a;} 
    .steps_bar p.current span { background:#f2672a;} 
    .steps_bar p.last { background-position:100% -180px; background-color:transparent;} 
    .steps_bar p.last span { background:#f1f1f1;} 
    .steps_bar p.last.current { background-position:100% -240px;} 
    .steps_bar p.last.current span { background:#f2672a;}

    .steps_bar{
        .steps_bar_pc{
            position: relative;
            .first{
                position: absolute;
                left:2px;
            }
        }
        .steps_bar_iphone {
            height:60px;
            &>div{
                color:#fff; 
                background:#f2672a;
                display: inline-block;
                padding-left:30px;
                min-width: 250px;
                height:100%;
                line-height: 60px;
                position: relative;
                left:-10px;
                &::before,&::after{
                    content:"";
                    width:0;
                    height:0;
                    transform: scaleY(1.5);
                    border-width:20px 0 20px 20px;
                    border-style:solid;
                    position: absolute;
                    top:10px;
                }
                &::before{
                    left:-0;
                    border-color:transparent transparent transparent #f1f1f1;
                }
                &::after{
                    right:-19px;
                    border-color:transparent transparent transparent #f2672a;
                }
            }
        }
        .preview{
            line-height: 60px;
            font-weight: bold;
        }
    }
    /*@media only screen and (max-width: 1550px) and (min-width: 1121px) {*/
    .pcType .steps_bar .steps_bar_pc .bar-box{
        width: 80%;
        display: flex;
        height: 60px;
    }
    .pcType .steps_bar .steps_bar_pc .bar-box .bar-item{
        flex: 1;
    }
    .pcType .steps_bar .steps_bar_pc .bar-box .active-item{
        background-color: #f2672a;
        border-top: 1px solid #f1f1f1;
        border-bottom: 1px solid #f1f1f1;
    }
    .pcType .steps_bar .steps_bar_pc .bar-box .bar-item .front,.pcType .steps_bar .steps_bar_pc .bar-box .bar-item .end{
        top: -1px;
    }
    .pcType .steps_bar .steps_bar_pc .bar-box .bar-item .middle{
        position: relative;
        z-index: 100;
        line-height: normal;
        display: inline;
        position: absolute;
        top: 50%;
        left: 54%;
        height: auto;
        transform: translate(-50%,-50%);
        border-top: none;
        border-bottom: none;
        overflow-wrap: break-word;
        padding: 0 10px;
        box-sizing: border-box;
    }
</style>



// WEBPACK FOOTER //
// src/components/bar.vue